<h2>Zugang bearbeiten</h2>

<ng-container *ngIf="data">

  <h3>Informationen zum Zugang</h3>
  <table class="mat-table data-table" [style]="{'margin-top': '25px'}">
    <ng-container *ngIf="data.external_customer_id">
      <tr>
        <th>Zugang für</th>
        <td>{{data.external_customer_id}}</td>
      </tr>
    </ng-container>
    <tr *ngIf="data.id">
      <th>Zugangsnummer</th>
      <td>{{data.id}}</td>
    </tr>
    <tr *ngIf="data.start">
      <th>Zugang von</th>
      <td>{{data.start | date: 'shortDate'}}</td>
    </tr>
    <tr *ngIf="data.expires">
      <th>Zugang bis</th>
      <td>{{data.expires | date: 'shortDate'}}</td>
    </tr>
  </table>

  <ng-container *ngIf="data.claim2Users && data.claim2Users.length; else noC2u">
    <h3>Nutzer-Daten</h3>
    <table class="mat-table data-table" [style]="{'margin-top': '25px'}">
      <ng-container *ngFor="let c2u of data.claim2Users">
        <ng-container *ngIf="c2u.user">
          <tr>
            <th>ID</th>
            <td>{{c2u.user.id}}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{c2u.user.name}}</td>
          </tr>
          <tr>
            <th>Registrierung</th>
            <td>{{c2u.user.entry | date: 'shortDate'}}</td>
          </tr>

          <tr>
            <th>Letzte Anmeldung</th>
            <td>{{c2u.user.lastLogin | date: 'shortDate'}}</td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </ng-container>
  <ng-template #noC2u>
    <strong>Dieser Zugang wurde noch nicht aktiviert.</strong>
    <p>
      <button mat-stroked-button color="accent" (click)="resendInvitation()" class="left">E-Mail-Einladung erneut senden
      </button>
    </p>
  </ng-template>
</ng-container>
